import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { teamActivityService } from '../services/team-activity.service';
import { HEARTBEAT_MS, shouldBeat } from '../utils/user-activity';

const beat = (page: string) => {
  if (shouldBeat()) teamActivityService.heartbeat(page).catch(() => {});
};

export function useActivityHeartbeat(): void {
  const { pathname } = useLocation();
  useEffect(() => { beat(pathname); }, [pathname]);
  useEffect(() => {
    const id = setInterval(() => beat(window.location.pathname), HEARTBEAT_MS);
    return () => clearInterval(id);
  }, []);
}
